import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";
import SummaryReportHeader from "../../components/SRHHeaders/SummaryReportHeader";
import { generateGuid } from "./../../modules/guid";
import _ from "lodash";

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    let checkedForDefaultReport = false;

    axios.get(`/api/default-summary-report-tree?u=${generateGuid()}`).then(res => {
      const defaultPage = props.user.reportsSettings ? props.user.reportsSettings.defaultPage : "";
      const defaultSummaryReportTreeNodeId = res.data.reportId;
      if (defaultPage) {
        this.props.history.push(defaultPage);
      } else if (defaultSummaryReportTreeNodeId) {
        this.props.history.push(`/summary-reports/${defaultSummaryReportTreeNodeId}`);
      } else {
        this.props.history.push("/summary-reports");
      }
    }).catch(err => {
      this.props.history.push("/summary-reports");
    });

    this.state = {
      checkedForDefaultReport,
    };
  }

  render() {
    return (
      <div>
        {!this.state.checkedIsNewAccount && (
          <Dimmer active>
            <Loader />
          </Dimmer>
        )}
        {this.state.checkedIsNewAccount && (
          <div>
            <SummaryReportHeader {...this.props} />
          </div>
        )}
      </div>
    );
  }
}

export default connect(store => {
  return {
    user: store.user,
  };
})(SignIn);



// WEBPACK FOOTER //
// ./src/pages/LandingPage/index.jsx